// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"91":"bee71dec","212":"faba76ba","214":"d0c71a97","461":"25797e29","505":"7da70936"}[chunkId] + ".chunk.js";
};